import { useCallback, useEffect, useState } from 'react';
import api from '../lib/api';

// Live pickup promise: base prep time + any rush delay the kitchen turned on.
export function usePrepTime(pollMs = 0) {
  const [prep, setPrep] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/prep-time');
      setPrep(data);
    } catch (_) { /* keep last value */ }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!pollMs) return undefined;
    const t = setInterval(load, pollMs);
    return () => clearInterval(t);
  }, [load, pollMs]);

  return { prep, reload: load };
}
